import { Component, OnDestroy, OnInit } from '@angular/core';
import { OPD_CONST } from '../../properties/opd-static-properties';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from 'projects/lib/medcare-core-lib/src/lib/services/auth.service';
import { SearchService } from 'projects/lib/medcare-core-lib/src/lib/services/search.service';
import { UtilsService } from 'projects/lib/medcare-core-lib/src/lib/services/utils.service';
import { opdNavigation } from '../../properties/opd-navigation-properties';
import { GeneralUrlService } from '../../services/SgeneralUrl.service';
import { MasterUrlService } from '../../services/SmasterUrl.service';
import { patientGetDataservice } from '../../services/SpatientGetData.service';
import { SearchHeaderService } from '../../services/SsearchHeader.service';
import { OPD_API_URL } from 'projects/lib/medcare-core-lib/src/lib/regproperties/opd-url-properties';
import { thEnConverterService } from 'projects/lib/medcare-core-lib/src/lib/services/thEnConverterService';
import { Langauge } from 'projects/lib/medcare-core-lib/src/lib/enums/configuration-modules.enum';
import { MultiLanguageService } from 'projects/lib/medcare-core-lib/src/lib/core/multi-language/multi-language.service';

@Component({
  selector: 'app-audit-trails',
  templateUrl: './audit-trails.component.html',
  styleUrl: './audit-trails.component.scss',
  providers: [DatePipe]
})
export class AuditTrailsComponent implements OnInit, OnDestroy {
  searchCriteria: any = null;
  patientList: any[] = [];

  patientId: string = "";

  unitCode: string;

  refreshTime: string = "";
  hidePatientSearch = false;
  patientInfoDisplay: string = "";
  patientForm: boolean = false;
  private subscriptionList = new Subscription();
  _onDestroy: Subject<boolean> = new Subject<boolean>();
  tempPatientRef: {
    system: string;
    code: String;
    display: string;
  } = {
      system: "",
      code: "",
      display: "",
    };
  List: any[] = [];
  patientAge: {
    years: number;
    months: number;
    days: number;
  } = {
      years: null,
      months: null,
      days: null,
    };
  isPatientType: string = "";
  langaugeValue: string;
  fields: string[];
  fieldRows: any[] = [];
  displayedColumns: string[] = ['field'];
  auditColumns: string[] = [];
  fieldMap = [
    { key: 'title', translationKey: 'MergeListPage.title' },
    { key: 'primaryType', translationKey: 'MergeListPage.primaryIdentification' },
    { key: 'primaryNo', translationKey: 'MergeListPage.primaryIdentificationNo' },
    { key: 'secondoryType', translationKey: 'MergeListPage.secondaryIdentification' },
    { key: 'secondoryNo', translationKey: 'MergeListPage.secondaryIdentificationNo' },
    { key: 'name', translationKey: 'MergeListPage.patientName' },
    { key: 'gender', translationKey: 'MergeListPage.gender' },
    { key: 'Dob', translationKey: 'MergeListPage.dob' },
    { key: 'vip', translationKey: 'MergeListPage.vip' },
    { key: 'deceased', translationKey: 'MergeListPage.deceased' },
    { key: 'category', translationKey: 'MergeListPage.patientCategory' },
    { key: 'race', translationKey: 'MergeListPage.race' },
    { key: 'mobileNo', translationKey: 'MergeListPage.mobileNo' },
    { key: 'email', translationKey: 'MergeListPage.email' }
  ];

  constructor(
    public searchHead: SearchHeaderService,
    private searchService: SearchService,
    public snackBar: MatSnackBar,
    public authService: AuthService,
    public generalApiService: GeneralUrlService,
    private datepipe: DatePipe,
    private utilsService: UtilsService,
    public masterApiService: MasterUrlService,
    public patientDataService: patientGetDataservice,
    private router: Router,
    private thConvertService:thEnConverterService,
    private translateService: MultiLanguageService
  ) { }

  ngOnInit(): void {
     this.langaugeValue=localStorage.getItem("lan");
    this.initSearchFilter();
    let isAuditReq = localStorage.getItem(OPD_CONST.PatientAudit);
    this.authService.getUnit().then((value: any) => {
      this.unitCode = value.unitCode;
      if (isAuditReq != undefined) {
        let patient = JSON.parse(isAuditReq);
        this.getPatientAudit(patient);
      }
    });
  }
  /**
 *Destroy method
 *
 * @memberof PatientRegistrationComponent
 */
  ngOnDestroy() {
    this.searchService.setSearch([]);
    this.subscriptionList.unsubscribe();
  }

  public initSearchFilter() {
    let url = !this.patientForm
      ? OPD_API_URL.M_PAT_REG_SEARCH
      : OPD_API_URL.M_PAT_REG_TYPE_SEARCH;
    this.subscriptionList.add(
      this.searchHead.getTypeSearch(url).subscribe((data: any) => {
        this.searchHead.updateSearchHeader(data);
      })
    );

    this.subscriptionList.add(
      this.searchService.getResult.subscribe((result) => {
        let keysArray = Object.keys(result);
        let hasValue = false;
        
        for (let i = 0; i < keysArray.length; i++) {
          let value = result[keysArray[i]];
          if (
            value !== "" && value !== null && value !== undefined && value !== false && 
            value.endDate !== null && value.startDate !== null &&
            value !== "Staff" && value !== "Student" && value !== "Patient" 
          ) {
            hasValue = true;
            break; 
          }
        }
        
        if (hasValue) {
          this.searchCriteria = this.searchHead.SetPatientSearch(result);
          this.isPatientType = result.userType;
          this.patientList = null;
          this.refreshTime = new Date().toString();
          this.hidePatientSearch = false;
        } else {
           this.snackBar.open("Warning", "Please select at least one search parameter to proceed with the data search.", {
            duration: 3000,
          });
        }
      })
    );
    let quickSearch = this.searchService.getElasticSearch.subscribe(
      (quickSearch) => {
        let result = { mrn: quickSearch };
        this.searchCriteria = this.searchHead.SetPatientSearch(result);
        this.patientList = null;
        this.refreshTime = new Date().toString();
        this.hidePatientSearch = false;
      }
    );
    this.subscriptionList.add(quickSearch);
  }
  patientOnSelect(patient) {
    this.getPatientAudit(patient);
  }
  getPatientAudit(patient) {
    localStorage.removeItem(OPD_CONST.PatientAudit);
    this.patientForm = false;
    this.patientId = patient.id;
    this.generalApiService
      .getTypeApi(
        OPD_API_URL.OPD_SERVICE,
        OPD_API_URL.GET_PATIENT_AUDIT + this.patientId
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any) => {
        this.List = [];
        if (res) {
          res.forEach(element => {
            let date = this.epochToDateConverter(element.performedOn.value);
            let obj = {
              id: element.id ? element.id.value : "",
              // auditDate: element.performedOn ? this.epochToDateConverter(element.performedOn.value) : "",
              auditDate :date
                ? (this.langaugeValue === Langauge.TH
                  ? this.thConvertService.convertThaiDateFormat(date)
                  : this.datepipe.transform(date,"dd/MM/yyyy hh:mm aa" ))
                : null,
              audit: element.performedOn ? element.performedOn : "",
              user: element.createdBy ? element.createdBy : "",
              title: element.title ? element.title : "",
              name: element.name ? element.name : "",
              mrn: element.mrn ? element.mrn : "",
              primaryType: element.primaryIdentifierType ? element.primaryIdentifierType : "",
              primaryNo: element.primaryIdentifierNo ? element.primaryIdentifierNo : "",
              secondoryType: element.secondaryIdentifierType ? element.secondaryIdentifierType : "",
              secondoryNo: element.secondaryIdentifierNo ? element.secondaryIdentifierNo : "",
              gender: element.gender ? element.gender : "",
              Dob: element.birthDate ? (this.langaugeValue == Langauge.TH
                ? this.thConvertService.convertToThaiFullDateWithOutTime(element.birthDate.value)
                :this.datepipe.transform(element.birthDate.value, "dd/MM/yyyy"))
              : null,
              vip: element.vip == true ? "Yes" : "No",
              deceased: element.isDeceased ? element.isDeceased : "",
              category: element.patientCategory ? element.patientCategory : "",
              nationality: element.nationality ? element.nationality : "",
              race: element.race ? element.race : "",
              mobileNo : element.mobileNumber ? element.mobileNumber : "",
              email : element.email ? element.email : "",
            }
            this.List.push(obj);
          });
          const keys = this.fieldMap.map(f => f.translationKey);

          this.translateService.translate.stream(keys).subscribe(translations => {
            let translatedFields = this.fieldMap.map(f => ({
              key: f.key,
              label: translations[f.translationKey]
            }));
        
            this.transformAuditData(this.List, translatedFields);
          });
          this.fields = Object.keys(this.List[0]?.data || {});

          // this.dataSource = new MatTableDataSource(this.List);
          this.patientInfoDisplay = "";
          var dobFormatted = "";
          var patientAge = undefined;
          this.tempPatientRef.code = patient.mrn;
          this.tempPatientRef.system = patient.id;
          this.tempPatientRef.display = patient.name;
          if (patient.dateOfBirth) {
            dobFormatted =  this.langaugeValue ==  Langauge.TH
            ? this.thConvertService.convertToThaiFullDateWithOutTime(patient.dateOfBirth)
            :this.datepipe.transform(patient.dateOfBirth, "dd/MM/yyyy");
            let dobDate = new Date(patient.dateOfBirth);
            patientAge = this.utilsService.getAge(dobDate);
            patientAge =
              patientAge > 1
                ? "(" + patientAge + " Years)"
                : "(" + patientAge + " Year)";
          }
          this.patientInfoDisplay =
            patient.mrn +
            " / " +
            patient.fullName +
            " / " +
            (patient.gender ? patient.gender : "Unknown") +
            " / " +
            (patient.dateOfBirth ? dobFormatted + " " + patientAge : "");
        }
      });
  }
  // calculateDob(value: number, type: string) {
  //   let formRegistration = this.formRegistration.controls;
  //   if (type == "year") this.patientAge.years = value;

  //   if (type == "month") this.patientAge.months = value;

  //   if (type == "day") this.patientAge.days = value;

  //   if (
  //     this.patientAge.years > 0 &&
  //     this.patientAge.years < 151 &&
  //     this.patientAge.months > 0 &&
  //     this.patientAge.months < 13 &&
  //     this.patientAge.days > 0 &&
  //     this.patientAge.days < 32
  //   ) {
  //     var birthDate = moment()
  //       .subtract(Number(this.patientAge.years), "years")
  //       .subtract(Number(this.patientAge.months), "months")
  //       .subtract(Number(this.patientAge.days), "days");
  //     let normalDate = birthDate.toDate();
  //     formRegistration['dateOfBirth'].setValue(normalDate);
  //     formRegistration['realdob'].setValue(true);
  //   }
  // }
  transformAuditData(auditData: any[],translatedFields: any[]) {
    const rows: any[] = translatedFields.map(f => ({ field: f.label }));
    
    auditData.forEach((audit, index) => {
      const colName = `${audit.user.value} at ${audit.auditDate}`;
      this.auditColumns.push(colName);
      this.displayedColumns.push(colName);
  
      translatedFields.forEach((f, i) => {
        const valueWrapper = audit[f.key];
        let value = valueWrapper?.hasOwnProperty('value') ? valueWrapper.value : valueWrapper;
        if (typeof value === 'boolean') {
          value = value.toString();
        }
        rows[i][colName] = value;
      });
    });
  
    this.fieldRows = rows;
  }

  epochToDateConverter(epoch: number): string {
    try {
      const epochString = epoch.toString().replace(/\D/g, "");
      const length = epochString.length;
      if (length == 10) {
        var d = new Date(0);
        d.setUTCSeconds(epoch);
      } else {
        var d = new Date(0);
        d.setUTCMilliseconds(epoch);
      }
      const datePipe = new DatePipe("en-US");
      const formattedDate = datePipe.transform(
        d,
        "EEE, LLLL dd, yyyy , hh:mm a"
      );
      return formattedDate;
    } catch (ex) {
      return "";
    }
  }
  backToRegistration() {
    this.router.navigate([opdNavigation.OPD_PATIENT_NAVIGATE]);
  }

  isDifferent(field: string, value: string): boolean {
    const baseValue = this.List[0].data[field];
    return this.List.some(item => item.data[field] !== baseValue);
  }
}
